module.exports = __webpack_public_path__ + "static/media/big_white_exclamation_icon.56fe50e7.svg";